<template>
  <yd-dialog
    title="添加保险信息"
    :visible.sync="dialogVisible"
    append-to-body
    destroy-on-close
    @close="closeClick"
    width="900px"
  >
    <div class="tipsBox">
      <i class="el-icon-warning-outline"></i>
      <span>
        1.保费、保额请输入数字，如：20万保额请输入2000000；
        2.需上传交强险、承运人责任险、商业保险，并上传保单文件</span
      >
    </div>
    <el-form label-width="150px" :model="form" :rules="rules" ref="form">
      <el-form-item label="保单图片" required>
        <upload-image
          :isMultiple="true"
          :code="'vehicle-insurance'"
          :file="carInsuranceImg"
          :instructionText="'上传保单照片/PDF'"
          :accept="'.jpg,.jpeg,.png,.JPG,.JPEG,.PBG,.pdf'"
          @uploadSuccess="getcarInsuranceImg"
          @remove="getcarInsuranceImg"
        />
      </el-form-item>
      <el-form-item label="保险类型：" prop="insuranceType">
        <el-select
          v-model="form.insuranceType"
          filterable
          placeholder="请选择"
          clearable
          style="width: 200px"
        >
          <el-option
            v-for="(item, index) in insuranceTypeList"
            :key="index"
            :label="item.label"
            :value="item.key"
          />
        </el-select>
      </el-form-item>
      <el-form-item label="保险号：" prop="policyNo">
        <el-input v-model="form.policyNo" clearable style="width: 200px" />
      </el-form-item>
      <el-form-item label="保险公司：" prop="insuranceCompany">
        <el-input v-model="form.insuranceCompany" clearable style="width: 200px" />
      </el-form-item>
      <el-form-item label="保费：" prop="premium">
        <el-input v-model="form.premium" clearable style="width: 200px" />
      </el-form-item>
      <el-form-item label="保额：" prop="sumAssured">
        <el-input v-model="form.sumAssured" clearable style="width: 200px" />
      </el-form-item>
      <el-form-item label="保险生效日期：" prop="insurancePeriodBegin">
        <el-date-picker
          v-model="form.insurancePeriodBegin"
          type="date"
          placeholder="选择日期"
          format="yyyy 年 MM 月 dd 日"
          value-format="yyyyMMdd"
          style="width: 200px"
        />
      </el-form-item>
      <el-form-item label="保险到期时间：" prop="insurancePeriodEnd" class="is-required">
        <el-date-picker
          v-model="form.insurancePeriodEnd"
          type="date"
          placeholder="选择日期"
          format="yyyy 年 MM 月 dd 日"
          value-format="yyyyMMdd"
          style="width: 200px"
        />
      </el-form-item>
    </el-form>

    <div slot="footer" class="dialog-footer">
      <el-button @click="closeClick">取 消</el-button>
      <el-button type="primary" @click="saveCarInsurance">确 定</el-button>
    </div>
  </yd-dialog>
</template>

<script>
  import UploadImage from '@/components/newUpload/index.vue'
  import { uuidv5 } from '@/util/util'
  import { cloneDeep, isEmpty } from 'lodash-es'
  import dayjs from 'dayjs'
  export default {
    components: {
      UploadImage
    },
    props: {
      visible: {
        type: Boolean,
        default: false
      },
      carInsuranceForm: {
        type: Object,
        default: () => {}
      }
    },
    data() {
      const validateDate = (rule, value, callback) => {
        if (!this.form.insurancePeriodBegin) {
          callback()
          return
        }
        if (!this.form.insurancePeriodEnd) {
          callback()
          return
        }
        if (dayjs(this.form.insurancePeriodBegin).isAfter(dayjs(this.form.insurancePeriodEnd))) {
          callback(new Error(rule.msg))
          return
        }
        callback()
      }
      return {
        form: {
          isDelete: 0
        },
        carInsuranceImg: [],
        insuranceTypeList: [
          { label: '交强险', key: 1 },
          { label: '商业险', key: 2 },
          { label: '承运人责任险', key: 3 }
        ],
        rules: {
          insuranceType: [{ required: true, message: '请选择保险类型', trigger: 'change' }],
          policyNo: [{ required: true, message: '请输入保险号', trigger: 'blur' }],
          insuranceCompany: [{ required: true, message: '请输入保险公司', trigger: 'blur' }],
          premium: [
            {
              pattern: /(^[1-9]([0-9]+)?(\.[0-9]{1,2})?$)|(^(0){1}$)|(^[0-9]\.[0-9]([0-9])?$)/,
              required: true,
              message: '请输入数字，保留2位小数',
              trigger: 'blur'
            }
          ],
          sumAssured: [
            {
              pattern: /(^[1-9]([0-9]+)?(\.[0-9]{1,2})?$)|(^(0){1}$)|(^[0-9]\.[0-9]([0-9])?$)/,
              required: true,
              message: '请输入数字，保留2位小数',
              trigger: 'blur'
            }
          ],
          insurancePeriodBegin: [
            { required: true, message: '请选择保险生效时间', trigger: 'change' },
            { validator: validateDate, trigger: 'change', msg: '保险生效时间不能大于保险到期时间' }
          ],
          insurancePeriodEnd: [
            { required: true, message: '请选择保险到期时间', trigger: 'change' },
            { validator: validateDate, trigger: 'change', msg: '保险到期时间不能小于保险生效时间' }
          ]
        },
        dialogVisible: false
      }
    },
    mounted() {
      this.form = cloneDeep(this.carInsuranceForm)
      if (this.form.img) {
        const imgList = this.form.img.split(',')
        imgList.forEach((item) => {
          this.carInsuranceImg.push({ url: item })
        })
      }
      this.dialogVisible = this.visible
      this.$nextTick(() => {
        this.$refs.form && this.$refs.form.clearValidate()
      })
    },
    methods: {
      getcarInsuranceImg(arr) {
        this.carInsuranceImg = arr
      },
      closeClick() {
        this.carInsuranceImg = []
        this.form = {
          isDelete: 0
        }
        this.$emit('closeClick')
      },
      saveCarInsurance() {
        if (isEmpty(this.carInsuranceImg)) {
          this.$message.error('请上传保单')
          return
        }
        const list = this.carInsuranceImg.map((item) => {
          return item.url
        })
        this.form.img = list.join(',')

        this.$refs.form.validate((valid) => {
          if (valid) {
            this.form.isDelete = 0
            if (!this.form.id && !this.form.uuid) {
              this.form.uuid = uuidv5()
            }
            this.$emit('saveCarInsurance', this.form)
          } else {
            return false
          }
        })
      }
    }
  }
</script>

<style lang="scss" scoped>
  .tipsBox {
    display: flex;
    align-items: center;
    margin-bottom: 10px;
    margin-left: 30px;
    font-size: 14px;
    color: #f56c6c;
  }
</style>
